import { motion } from "framer-motion";

export default function Divider({ label, className = "" }) {
  return (
    <div
      className={`flex items-center gap-4 text-champagne my-10 ${className}`}
      aria-hidden="true"
    >
      <motion.span
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        style={{ transformOrigin: "right" }}
        className="flex-1 h-px bg-gradient-to-r from-transparent via-champagne/50 to-champagne/70"
      />
      {label ? (
        <span className="font-arabic text-lg text-champagne tracking-wider">
          {label}
        </span>
      ) : (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <motion.path
            initial={{ pathLength: 0 }}
            whileInView={{ pathLength: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4 }}
            d="M12 2 C8 8, 8 16, 12 22 M12 2 C16 8, 16 16, 12 22 M4 12 H20"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
        </svg>
      )}
      <motion.span
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        style={{ transformOrigin: "left" }}
        className="flex-1 h-px bg-gradient-to-l from-transparent via-champagne/50 to-champagne/70"
      />
    </div>
  );
}
